import { x as c, c as x } from "../lit-element-8JrrHldg.js";
import { n as l } from "../property-4FoNj0Pi.js";
import { n as E } from "../ref-ArR26hg7.js";
import { o } from "../if-defined-Cd-e8xtV.js";
import { o as O } from "../style-map-F8T0o2lr.js";
import { I as P } from "../IdController-Cpj_A6H5.js";
import "./pwc-label.js";
import "./pwc-input-surface.js";
import "./pwc-input-message.js";
import "./pwc-icon.js";
import "../cross-De9fASU6.js";
import { t as C } from "../time-B7nTmSbZ.js";
import { c as S } from "../clsx-DB4S2d7J.js";
import { l as z } from "../lodash-DXs1LrID.js";
import { P as T } from "../pwc-interactive-element-B6286Ky3.js";
import { p as h } from "../pwcProperty-CTLG9yrF.js";
class M {
  /**
   * @param prop - Prop to observe
   * @param fn - Function to execute on change
   */
  constructor(t, s) {
    this.subjects = [], this.prop = t, this.fn = s;
  }
  /**
   * @param subject - Subject to observe
   */
  observe(t) {
    if (this.subjects.indexOf(t) !== -1)
      return;
    const { prop: s } = this;
    let r = t[s];
    this.subjects.push(t);
    const n = () => {
      this.subjects.indexOf(t) !== -1 && (r !== t[s] && (this.fn(t[s], r), r = t[s]), requestAnimationFrame(n));
    };
    requestAnimationFrame(n);
  }
  /**
   * Unobserve a given subject
   * @param subject - Subject to unobserve
   */
  unobserve(t) {
    this.subjects = this.subjects.filter((s) => s !== t);
  }
  /**
   * Unobserve all observed subjects
   */
  disconnect() {
    this.subjects = [];
  }
}
var q = Object.defineProperty, I = Object.getOwnPropertyDescriptor, a = (e, t, s, r) => {
  for (var n = r > 1 ? void 0 : r ? I(t, s) : t, d = e.length - 1, u; d >= 0; d--)
    (u = e[d]) && (n = (r ? u(t, s, n) : u(n)) || n);
  return r && n && q(t, s, n), n;
}, $ = (e, t, s) => {
  if (!t.has(e))
    throw TypeError("Cannot " + s);
}, b = (e, t, s) => ($(e, t, "read from private field"), t.get(e)), v = (e, t, s) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, s);
}, g = (e, t, s) => ($(e, t, "access private method"), s), p, m, w, f, y;
const _ = "pwc-textarea";
let i = class extends T {
  constructor() {
    super(...arguments), v(this, m), v(this, f), this.idController = new P(this, {
      base: "PwcTextarea",
      children: ["label", "textarea"]
    }), this.slotControlled = ["label"], v(this, p, z.debounce(
      () => {
        this.resize === "auto" && this.interactiveEl && (this.interactiveEl.style.height = "auto", this.interactiveEl.style.height = `${this.interactiveEl.scrollHeight}px`);
      },
      10,
      { leading: !0 }
    )), this.resizeObserver = new ResizeObserver(b(this, p)), this.valueObserver = new M("value", b(this, p));
  }
  clear() {
    this.value = "", this.emit("p-input", { detail: "" }), this.focus();
  }
  setSelectionRange(e, t, s = "none") {
    var r;
    (r = this.interactiveEl) == null || r.setSelectionRange(
      e,
      t,
      s
    );
  }
  updated(e) {
    super.updated(e), e.has("resize") && (e.get("resize") === "auto" ? (this.resizeObserver.observe(this.interactiveEl), this.valueObserver.observe(this.interactiveEl)) : (this.resizeObserver.disconnect(), this.valueObserver.disconnect()));
  }
  async connectedCallback() {
    super.connectedCallback(), await this.updateComplete, this.resize == "auto" && requestAnimationFrame(() => {
      this.resizeObserver.observe(this.interactiveEl), this.valueObserver.observe(this.interactiveEl);
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.resizeObserver.disconnect(), this.valueObserver.disconnect();
  }
  get showClearButton() {
    return this.clearable && !(this.hidden || this.disabled) && this.value.length;
  }
  get selectionStart() {
    var e;
    return ((e = this.interactiveEl) == null ? void 0 : e.selectionStart) ?? 0;
  }
  set selectionStart(e) {
    this.interactiveEl && (this.interactiveEl.selectionStart = e);
  }
  get selectionEnd() {
    var e;
    return ((e = this.interactiveEl) == null ? void 0 : e.selectionEnd) ?? 0;
  }
  set selectionEnd(e) {
    this.interactiveEl && (this.interactiveEl.selectionEnd = e);
  }
  get describedBy() {
    return this.description ? `${this.idController.child.label}__description` : void 0;
  }
  render() {
    const {
      idController: {
        id: e,
        child: { label: t, textarea: s }
      },
      slotted: r
    } = this;
    return c`
      <div class="PwcTextarea" id=${e}>
        <pwc-label
          id=${t}
          class="PwcTextarea__label"
          for=${s}
          description=${o(this.description)}
          ?disabled=${this.disabled}
          ?required=${this.required}
        >
          ${r.label ? "" : this.label}
          <p-slot .host=${this} name="label"></p-slot>
          <p-slot
            .host=${this}
            name="description"
            p-slot="description"
          ></p-slot>
        </pwc-label>
        <div class="PwcTextarea__inner">
          <p-slot .host=${this} name="prepend-outer"></p-slot>
          <pwc-input-surface
            class="PwcTextarea__inputSurface"
            status=${o(this.status)}
            ?focused=${this.focused}
            ?readonly=${this.readonly}
            ?disabled=${this.disabled}
          >
            <p-slot .host=${this} name="prepend"></p-slot>
            <textarea
              style=${O({
      resize: this.resize === "auto" ? "none" : this.resize
    })}
              ${E(this.interactiveElementRef)}
              id=${s}
              class=${S("PwcTextarea__input")}
              aria-describedby=${o(this.describedBy)}
              name=${o(this.name)}
              title=${o(this.title)}
              placeholder=${o(this.placeholder)}
              minlength=${o(this.minlength)}
              maxlength=${o(this.maxlength)}
              rows=${o(this.rows)}
              .value=${this.value}
              ?autofocus=${this.autofocus}
              ?readonly=${this.readonly}
              ?disabled=${this.disabled}
              ?required=${this.required}
              @input=${g(this, m, w)}
              @change=${g(this, f, y)}
            ></textarea>
            ${this.showClearButton ? c` <button class="PwcTextarea__clear" @click=${this.clear}>
                  <pwc-icon
                    class="PwcTextarea__clear__icon"
                    icon="cross"
                  ></pwc-icon>
                </button>` : ""}
            <p-slot .host=${this} name="append"></p-slot>
          </pwc-input-surface>
          <p-slot .host=${this} name="append-outer"></p-slot>
        </div>
        <div class="PwcTextarea__bottom">
          ${this.hideDetails ? "" : c` <pwc-input-message
                .errorMessages=${this.errorMessages}
                .warningMessages=${this.warningMessages}
                .successMessages=${this.successMessages}
                .hintMessage=${this.focused && this.hintMessage || void 0}
              ></pwc-input-message>`}
          ${this.counter ? c` <div class="PwcTextarea__counter">
                ${this.maxlength ? this.maxlength - this.value.length : this.value.length}
              </div>` : ""}
        </div>
      </div>
    `;
  }
};
p = /* @__PURE__ */ new WeakMap();
m = /* @__PURE__ */ new WeakSet();
w = async function(e) {
  await C();
  const t = this.value = e.target.value;
  this.emit("p-input", { detail: t });
};
f = /* @__PURE__ */ new WeakSet();
y = function(e) {
  this.emit("p-change", this.event(e));
};
i.tagName = _;
i.resizeOptions = [
  "horizontal",
  "vertical",
  "both",
  "none",
  "auto"
];
a([
  l({ type: String })
], i.prototype, "name", 2);
a([
  h({ type: String, default: "" })
], i.prototype, "value", 2);
a([
  l({ type: String })
], i.prototype, "label", 2);
a([
  h({ type: String, default: "" })
], i.prototype, "placeholder", 2);
a([
  h({ type: String, default: "" })
], i.prototype, "title", 2);
a([
  l({ type: Boolean })
], i.prototype, "clearable", 2);
a([
  h({ type: Boolean, default: !1 })
], i.prototype, "counter", 2);
a([
  h({ type: Number, default: 2 })
], i.prototype, "rows", 2);
a([
  l({ type: String })
], i.prototype, "resize", 2);
a([
  l({ type: Number })
], i.prototype, "minlength", 2);
a([
  l({ type: Number })
], i.prototype, "maxlength", 2);
a([
  l({ type: String })
], i.prototype, "description", 2);
i = a([
  x(_)
], i);
export {
  i as PwcTextarea
};
